import { HttpMethod, PaginatedResponse, Type } from "@/Utils/request/types";
import {
  CasteCategoryRecord,
  CoverageTypeRecord,
  GovernmentSchemeRecord,
  NationalityRecord,
  ReligionRecord,
} from "@/types/emr/patient/patientMasterData";

export default {
  listReligions: {
    path: "/api/v1/religion/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<ReligionRecord>>(),
  },
  listCasteCategories: {
    path: "/api/v1/caste_category/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<CasteCategoryRecord>>(),
  },
  listNationalities: {
    path: "/api/v1/nationality/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<NationalityRecord>>(),
  },
  listCoverageTypes: {
    path: "/api/v1/coverage_type/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<CoverageTypeRecord>>(),
  },
  listGovernmentSchemes: {
    path: "/api/v1/government_scheme/",
    method: HttpMethod.GET,
    TRes: Type<PaginatedResponse<GovernmentSchemeRecord>>(),
  },
};
